import { useCallback, useState, type FormEvent } from "react";
import type { LeagueCandidate } from "@tnp/contracts";
import Button from "../../../../shared/components/Button";
import { useLeagueResource } from "../../shared/hooks/useLeagueResource";
import { searchLeagueCandidates } from "../../shared/services/leagueMembershipService";
import { getLeagueRosterTexts } from "../../shared/leagueRosterTexts";
import LeagueFeedback from "../../shared/components/LeagueFeedback";
import LeagueLoadError from "../../shared/components/LeagueLoadError";

type Props = { token: string; leagueId: string; divisionId: string; selectedIds: number[]; onAdd: (candidate: LeagueCandidate) => void };
export default function LeagueAthleteSearch({ token, leagueId, divisionId, selectedIds, onAdd }: Props) {
  const t = getLeagueRosterTexts();
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const load = useCallback(() => searchLeagueCandidates(token, leagueId, divisionId, search, offset), [token, leagueId, divisionId, search, offset]);
  const resource = useLeagueResource(load);
  function submit(event: FormEvent) {
    event.preventDefault();
    if (search === input.trim() && offset === 0) resource.retry();
    else { setSearch(input.trim()); setOffset(0); }
  }
  const candidates = resource.data?.items.filter(item => !selectedIds.includes(item.id)) || [];
  return <section className="league-panel">
    <form className="league-search league-form" onSubmit={submit}>
      <label>{t.search}<input maxLength={100} value={input} onChange={e => setInput(e.target.value)} /></label>
      <Button type="submit">{t.searchAction}</Button>
    </form>
    {resource.loading ? <LeagueFeedback>{t.loading}</LeagueFeedback> : resource.error ? <LeagueLoadError error={resource.error} retry={resource.retry} /> : <>
      {!candidates.length && <LeagueFeedback>{t.noCandidates}</LeagueFeedback>}
      <ul className="league-athlete-list">{candidates.map(item => <li key={item.id}>
        <span>{item.name}{item.category && <small>{t.category}: {item.category}</small>}</span>
        <Button type="button" variant="ghost" disabled={selectedIds.length >= 256} aria-label={`${t.add}: ${item.name}`} onClick={() => onAdd(item)}>{t.add}</Button>
      </li>)}</ul>
      <div className="league-actions">
        {offset > 0 && <Button type="button" variant="ghost" onClick={() => setOffset(Math.max(0, offset - 20))}>{t.previous}</Button>}
        {resource.data?.nextOffset != null && <Button type="button" variant="ghost" onClick={() => setOffset(resource.data!.nextOffset!)}>{t.next}</Button>}
      </div>
    </>}
  </section>;
}
